// extracted by mini-css-extract-plugin
module.exports = {"button":"UISaveMenu_button__VIrXV","download__link":"UISaveMenu_download__link__3OZwJ"};